module.exports = __webpack_public_path__ + "static/media/how-bg@1.5x.f8f97dd5.png";